/* eslint-disable @typescript-eslint/ban-types */
import {
  ComponentOptionsMixin,
  ComponentPropsOptions,
  ComputedOptions,
  DefineComponent,
  EmitsOptions,
  ExtractPropTypes,
  MethodOptions,
} from 'vue';

export default function WithModel<
  PropsOptions extends Readonly<ComponentPropsOptions>,
  PropTypes extends ExtractPropTypes<PropsOptions>,
  K extends keyof PropTypes,
  RawBindings,
  D,
  C extends ComputedOptions = {},
  M extends MethodOptions = {},
  Mixin extends ComponentOptionsMixin = ComponentOptionsMixin,
  Extends extends ComponentOptionsMixin = ComponentOptionsMixin,
  E extends EmitsOptions = Record<string, any>,
  EE extends string = string,
  ModifiedProps = Omit<PropTypes, K> & ({ vModel: [PropTypes[K], K] } & Pick<PropTypes, K>)
>(
  component: any,
  // eslint-disable-next-line
  prop: any
): DefineComponent<ModifiedProps, RawBindings, D, C, M, Mixin, Extends, E, EE> {
  return component as any;
}
